import {Dict} from "../core/Reflection";
import {OptionId, SlotId} from "./StoryModel";

export class SlotsModel {

    private _slots: Dict<SlotId, OptionId> = {};

    public selectOption(slotId: SlotId, optionId: OptionId) {
        this._slots[slotId] = optionId;
    }

    public isOptionSelected(optionId: OptionId, slotId?: SlotId): boolean {
        if (slotId) {
            return this._slots[slotId] === optionId;
        }
        for (const p in this._slots) {
            if (this._slots.hasOwnProperty(p)) {
                const slot = p as SlotId;
                if (this._slots[slot] === optionId) {
                    return true;
                }
            }
        }
        return false;
    }

    public getSelectedOption(slotId: SlotId): OptionId | undefined {
        return this._slots[slotId];
    }

    public replaceOption(slotId: SlotId, oldOption: OptionId, newOption: OptionId) {
        if (this._slots[slotId] === oldOption) {
            this._slots[slotId] = newOption;
        }
    }

    public clone() {
        const model = new SlotsModel();
        for (const p in this._slots) {
            if ((this._slots as object).hasOwnProperty(p)) {
                model._slots[p as SlotId] = this._slots[p as SlotId];
            }
        }
        return model;
    }

    public clear() {
        this._slots = {};
    }
}
